import { render, staticRenderFns } from "./accountSet.vue?vue&type=template&id=28bd7213&scoped=true"
import script from "./accountSet.vue?vue&type=script&lang=js"
export * from "./accountSet.vue?vue&type=script&lang=js"
import style0 from "./accountSet.vue?vue&type=style&index=0&id=28bd7213&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bd7213",
  null
  
)

export default component.exports